import { render, staticRenderFns } from "./Stars.vue?vue&type=template&id=53196ba4&scoped=true&"
import script from "./Stars.vue?vue&type=script&setup=true&lang=js&"
export * from "./Stars.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Stars.vue?vue&type=style&index=0&id=53196ba4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53196ba4",
  null
  
)

export default component.exports